import React, { Component, Fragment } from 'react'
import {Media} from 'react-md';
import './Video.scss'

class Video extends Component {
  render() {
  	const { VideoUrl } = this.props;   
    return (
      <Fragment>
	    <Media aspectRatio="16-9">
	        <iframe src={VideoUrl} width="854" height="480" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen></iframe>
        </Media>
      </Fragment>
    )
  }
}   

export default Video


// WEBPACK FOOTER //
// ./src/components/Video/Video.js